import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import autoFillOperation from 'editor/src/store/editor/operation/autoFillOperation';
import { useDispatch } from 'editor/src/store/hooks';

import useCustomToastr from 'editor/src/component/CustomToastrComponent/useCustomToastr';

import { AutofillMarginOption } from './AutofillOptions';

const NOT_PLACED_TOAST_TIMEOUT = 10000;

// Runs autofill and tells the user how many photos were placed, and why any were left out
const useAutoFill = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const showToastr = useCustomToastr();

  return useCallback(
    (marginOption?: AutofillMarginOption) => {
      const result = dispatch(autoFillOperation(marginOption));
      if (!result) {
        return;
      }
      const { placed, notPlaced } = result;
      const total = placed + notPlaced;
      if (!notPlaced) {
        if (placed) {
          showToastr(
            'success',
            t('editor-autofill-all-placed', {
              defaultValue: 'Autofill placed {{placed}} of {{total}} photos.',
              placed,
              total,
            }),
          );
        }
        return;
      }
      showToastr(
        'info',
        t('editor-autofill-some-not-placed', {
          defaultValue:
            'Autofill placed {{placed}} of {{total}} photos. {{notPlaced}} did not fit: there are no empty pages or ' +
            'photo slots left. Add pages or clear a page, then run Autofill again. ' +
            'Tick "{{hideUsedPhotos}}" to see the photos that are not in the book.',
          placed,
          total,
          notPlaced,
          hideUsedPhotos: t('editor-hide-used-photos'),
        }),
        { timeOut: NOT_PLACED_TOAST_TIMEOUT },
      );
    },
    [dispatch, t, showToastr],
  );
};

export default useAutoFill;
